import { useToast } from './ToastContext';

const typeStyles = {
  success: 'bg-green-500',
  error: 'bg-red-500',
  info: 'bg-blue-600',
};

export function ToastContainer() {
  const { toasts, removeToast } = useToast();

  if (toasts.length === 0) return null;

  return (
    <div className="fixed top-4 right-4 z-50 flex flex-col gap-2">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`${typeStyles[toast.type]} min-w-72 rounded-lg px-4 py-3 text-sm text-white shadow-lg`}
        >
          <div className="flex items-center justify-between gap-2">
            <span>{toast.message}</span>
            <button
              onClick={() => removeToast(toast.id)}
              className="text-white/80 hover:text-white"
            >
              &times;
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
